import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { VoxelCheckboxModule, VoxelFormFieldModule, VoxelInputModule, VoxelLinkModule, VoxelModalModule } from '@voxel/mobile';
import { LottieAnimationViewModule } from 'ng-lottie';
import { SharedModule } from 'src/app/shared/shared.module';
import { IdentificationRoutes } from '../../identification/identification.routes';
import { InputAmountComponent } from './Input-Amount/Input-Amount.component';
import { LoanRoutes } from './loan.routes';
import { RequestLoanComponent } from './request-loan/request-loan.component';

import {
  VclAccordionModule,
  VclAlertModule,
  VclAutocompleteModule,
  VclCardTemplateModule,
  VclDatepickerModule,
  VclFormFieldModule,
  VclInputModule,
  VclModalModule,
  VclSelectModule,
  VclTableModule,
} from '@voxel/community';

import { PlazoMontoComponent } from './plazo-monto/plazo-monto.component';
import { MetodoDesembolsoComponent } from './metodo-desembolso/metodo-desembolso.component';
import { RequestEntityComponent } from './request-entity/request-entity.component';
import { AddLoanComponent } from './add-loan/add-loan.component';
import { CreditSelectionComponent } from './credit-selection/credit-selection.component';
import { OutlayOtherBankComponent } from './outlay-other-bank/outlay-other-bank.component';
import { ClientCreditsComponent } from './client-credits/client-credits.component';
import { CreditInfoComponent } from './credit-info/credit-info.component';
import { SupportDocumentsLoanComponent } from './support-documents-loan/support-documents-loan.component';
@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    LoanRoutes,
    SharedModule,
    VclModalModule,
    VoxelLinkModule,
    VoxelModalModule,
    VoxelCheckboxModule,
    IdentificationRoutes,
    VoxelFormFieldModule,
    VoxelInputModule,
    LottieAnimationViewModule.forRoot(),
    VclInputModule,
    VclFormFieldModule,
    ReactiveFormsModule,
    VclAlertModule,
    VclAutocompleteModule,
    VclCardTemplateModule,
    VclDatepickerModule,
    VclTableModule,
    VclSelectModule,
    VclAccordionModule,

  ],
  declarations: [
    RequestLoanComponent,
    InputAmountComponent,
    PlazoMontoComponent,
    MetodoDesembolsoComponent,
    RequestEntityComponent,
    AddLoanComponent,
    CreditSelectionComponent,
    OutlayOtherBankComponent,
    ClientCreditsComponent,
    CreditInfoComponent,
    SupportDocumentsLoanComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})

export class LoanModule { }
